/**
 * Model to manage the integration's related data.
 */
export class IntegrationModel {
    id: number;
    clientId: number;
    clientName: string;
    clientAccounts: string[];
    clientAccountNo: string;
    extAccId: string;
    extAccName: string;
    currency: string;
    status: string;
    type: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/integration.model.ts